import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'
import { PublisherModules } from '@/shared/types/clinic/configurations/publisherModules'

import { axios, Response } from '../index'

export interface GetConfigurationPublicationsResponse {
  id: string
  categories: GetConfigurationPublicationCategoryResponse[]
  isMandatory: boolean
  module: PublisherModules
}

export interface GetConfigurationPublicationCategoryResponse {
  id: string
  groupCategory: GroupConfigurationCategory
  isMandatory: boolean
}

const getConfigurationPublications = (): Response<
  GetConfigurationPublicationsResponse[]
> => {
  return axios.get(`/v1/publisher-settings`)
}

export default getConfigurationPublications
